export default __webpack_public_path__ + "static/media/kitchen4-afterB-1024w.74a08c26.webp";